<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择发货类型"
      width="80%"
      top="5vh">
    <el-table :data="dealMan">
      <el-table-column prop="deliveryTypeName" align="center" label="发运类型"/>
      <el-table-column prop="userName" align="center" label="发运人"/>
      <el-table-column prop="setTime" align="center" label="规定时间（天）"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
  export default {
    name: "DeliveryTypeSelect",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        index: "",
        groupIndex: "",
        dealMan: [
          { deliveryTypeName: "电机整机", userName: "电机仓库", account: "djck", setTime: 2 },
          { deliveryTypeName: "电机板卡", userName: "电机仓库", account: "djck", setTime: 2 },
          { deliveryTypeName: "电气产品", userName: "杜文萍", account: "duwp", setTime: 2 },
          { deliveryTypeName: "外购件", userName: "张成娟", account: "zhangcj", setTime: 3 },
          { deliveryTypeName: "自制品", userName: "严施丹", account: "yansd", setTime: 7 },
          { deliveryTypeName: "外购件", userName: "智显", account: "S0008002123", setTime: 3 },
          { deliveryTypeName: "外购件", userName: "蓝摩", account: "S0008002428", setTime: 3 },
        ],
      };
    },
    methods: {
      open(groupIndex, index) {
        this.index = index;
        this.groupIndex = groupIndex;
        this.dialogVisible = true;
      },
      onSelect(row) {
        row.index = this.index;
        row.groupIndex = this.groupIndex;
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
